// extracted by mini-css-extract-plugin
export default {"wrapper":"HU-z","availablePromoMessagesLabel":"IU-z","promoMessageList":"JU-z","promoMessage":"KU-z","appliedPromoMessage":"LU-z","promoMessageAmount":"MU-z"};